export default __webpack_public_path__ + "static/media/Gilroy-Light.896263ef.ttf";